import { useEffect, useState } from "react";

/**
 * A SOC widget that says "live" must actually be live. Without a ticker the now
 * marker, the live pulses and the countdowns freeze at the last render — which
 * on a dashboard left open on a wall screen can mean hours of quiet lying.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!Number.isFinite(intervalMs) || intervalMs <= 0) return;
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
